import _ from "lodash";
import {statusMessage, storedMessage} from "./followUp";

// Statuts d'action qui ne comptent pas dans l'avancement d'un work item
const IGNORED_ACTION_STATUSES = ['skipped', 'abandoned']

const statusId = status => _.isObject(status) ? status.id : status

// Statut d'un work item déduit de ses actions ; la surcharge manuelle (en pause, abandonné) l'emporte
export const deriveWorkItemStatus = (actions = [], override) => {
    const overrideId = statusId(override)
    if (overrideId) return overrideId

    const statuses = actions.map(action => statusId(action.status) || 'todo')
    const counted = statuses.filter(status => !IGNORED_ACTION_STATUSES.includes(status))

    if (!statuses.length) return 'todo'
    // « sans objet » est le statut initial des actions générées : rien ne compte encore
    if (!counted.length) return statuses.every(status => status === 'abandoned') ? 'abandoned' : 'todo'
    if (counted.every(status => status === 'done')) return 'done'
    if (counted.includes('blocked')) return 'blocked'
    if (counted.some(status => ['ongoing', 'done'].includes(status))) return 'ongoing'
    return 'todo'
}

// Recalcule et enregistre le statut d'un work item après l'enregistrement isolé d'une de ses actions ;
// un changement est tracé dans son « Suivi »
export const refreshWorkItemStatus = async (workItemId, context) => {
    const _id = new global.ObjectID(workItemId.toString())
    const workItem = await global.app.K.WorkItem.collection.findOne({_id}, {projection: {override: 1, status: 1}})
    if (!workItem) return

    const actions = await global.app.K.Action.collection
        .find({workItem: _id}, {projection: {status: 1}})
        .toArray()

    const status = deriveWorkItemStatus(actions, workItem.override)
    if (status === workItem.status) return

    const message = statusMessage(workItem.status, status, 'WorkItemStatus', context)
    await global.app.K.WorkItem.collection.updateOne(
        {_id},
        {$set: {status}, $push: {conversations: storedMessage(message, context)}}
    )
}
